module.exports = __webpack_public_path__ + "img/topicDomesticAppliances.1ea2a3d4.webp";